export default __webpack_public_path__ + "static/media/animalToLetter.00d4f584.png";